import { useTranslation } from "react-i18next";
import { CustomDropdown } from "../../_components/CustomDropdown";
import { ParkingFilter } from "../../_models/ParkingSpot";

interface Props {
    filter: ParkingFilter;
    floors: string[];
    onChangeFilters: (patch: Partial<ParkingFilter>) => void;
    className?: string;
}

export function ParkingFilters({ filter, floors, onChangeFilters, className = "" }: Props) {
    const { t } = useTranslation();

    // Small external labels give the dropdowns context ("what filter is
    // this?") without the `title` prop's bold inline prefix, which wasted
    // horizontal space by repeating the category name inside every button.
    const floorOptions = [
        CustomDropdown.buildOption("", t("mod_parking_floor_all")),
        ...floors.map((f) => CustomDropdown.buildOption(f, f)),
    ];

    const statusOptions = [
        CustomDropdown.buildOption("ALL", t("mod_parking_status_all")),
        CustomDropdown.buildOption("FREE", t("mod_parking_status_free")),
        CustomDropdown.buildOption("OCCUPIED", t("mod_parking_status_occupied")),
    ];

    return (
        <div className={`d-flex align-items-center pr-3 ${className}`}>
            <small className="text-muted mr-2 text-nowrap">
                {t("mod_parking_floor")}
            </small>
            <CustomDropdown
                options={floorOptions}
                value={filter.floor ?? ""}
                onChange={(value) => onChangeFilters({ floor: value || null })}
                isSearchable={false}
            />
            <small className="text-muted ml-3 mr-2 text-nowrap">
                {t("global_status")}
            </small>
            <CustomDropdown
                options={statusOptions}
                value={filter.status ?? "ALL"}
                onChange={(value) => onChangeFilters({ status: value })}
                isSearchable={false}
            />
        </div>
    );
}
